import React, { useState } from "react";
import ModalPictureProfile from "../../containers/ModalPictureProfile";
import UploadImageComponent from "../../utils/components/UploadImage/UploadImage";

export const UploadImage = ({ isUpdate, setFile, setPicture, picture, type, classNameUpload = '' }) => {
  //const [fileUrl, setfileUrl] = useState("")
  const [isShowPikerProfilePicture, setIsShowPikerProfilePicture] =
    useState(false);
  const selectPikerProfile = (e) => {
    e.stopPropagation();
    setIsShowPikerProfilePicture(!isShowPikerProfilePicture);
  };

  return (
    <>
      <ModalPictureProfile
        displayModal={isShowPikerProfilePicture}
        closeModal={selectPikerProfile}
        seturlProfilePicture={setPicture}
        setFile={setFile}
      />
      <UploadImageComponent
        isUpdate={isUpdate}
        classNameUpload={classNameUpload}
        type={type}
        fileUrl={picture}
        onClick={(e) => selectPikerProfile(e)}
      />
    </>
  );
};
